var exports = {
  "LL": "LexicalMessageComposer.module__editable___VmRIOG",
  "h5": "LexicalMessageComposer.module__richInputHost___VmRIOG",
  "I8": "LexicalMessageComposer.module__formSize___VmRIOG",
  "FY": "LexicalMessageComposer.module__paragraph___VmRIOG",
  "qf": "LexicalMessageComposer.module__placeholder___VmRIOG",
  "xL": "LexicalMessageComposer.module__marker___VmRIOG",
  "_u": "LexicalMessageComposer.module__blockquoteLine___VmRIOG",
  "iU": "LexicalMessageComposer.module__blockquoteMarker___VmRIOG",
  "Cr": "LexicalMessageComposer.module__bold___VmRIOG",
  "TN": "LexicalMessageComposer.module__italic___VmRIOG",
  "V1": "LexicalMessageComposer.module__underline___VmRIOG",
  "ZN": "LexicalMessageComposer.module__strike___VmRIOG",
  "aY": "LexicalMessageComposer.module__code___VmRIOG",
  "Po": "LexicalMessageComposer.module__mentionHost___VmRIOG",
  "ZJ": "LexicalMessageComposer.module__emojiHost___VmRIOG",
  "G5": "LexicalMessageComposer.module__command___VmRIOG",
  "Gx": "LexicalMessageComposer.module__slashSlot___VmRIOG",
  "Pe": "LexicalMessageComposer.module__slashSlotPlaceholder___VmRIOG",
  "ZW": "LexicalMessageComposer.module__slashSlotSeparator___VmRIOG",
  "Q$": "LexicalMessageComposer.module__optionalHint___VmRIOG",
};

module.exports = exports;
